"use client";

import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, ThumbsUp } from "lucide-react";
import Link from "next/link";
import { Button } from "./ui/button";
import { useScopedI18n } from "@/locales/client";
const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const t = useScopedI18n("cookieBanner");
  useEffect(() => {
    const cookieConsent = localStorage.getItem("cookieConsent");
    if (cookieConsent === null) {
      setShowBanner(true);
    }
  }, []);
  const handleConsent = (consent: boolean) => {
    localStorage.setItem("cookieConsent", consent.toString());
    setShowBanner(false);
  };
  return <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-component="CookieBanner" data-sentry-source-file="CookieBanner.tsx">
      {showBanner && <motion.div animate={{
      y: 0,
      opacity: 1
    }} className="fixed bottom-4 left-4 z-50 w-full max-w-2xl rounded-lg border bg-background p-4 text-primary shadow-lg" exit={{
      y: 100,
      opacity: 0
    }} initial={{
      y: 100,
      opacity: 0
    }}>
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <div className="flex items-center space-x-2">
              <Cookie className="h-6 w-6 shrink-0 text-primary" />
              <p className="text-sm">{t("cookieMessage")}</p>
            </div>
            <div className="flex flex-col space-y-2">
              <Button size="sm" variant="outline" onClick={() => handleConsent(false)}>
                {t("declineButton")}
              </Button>
              <Button size="sm" onClick={() => handleConsent(true)}>
                <ThumbsUp className="mr-2 h-4 w-4" />
                {t("acceptButton")}
              </Button>
            </div>
          </div>
          <div className="mt-2 text-center text-xs">
            <Link className="text-primary hover:underline" href="/legal/privacy-policy">
              {t("privacyPolicy")}
            </Link>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
export default CookieBanner;